module.exports = __webpack_public_path__ + "images/emoji/information_source.42d579f0b9c98738bfdc.png";